import React from "react";
import { Logout } from "ceicons";
import AvatarLetter from "../AvatarLetter";
import packageJson from "../../../../package.json";

export default function User(props) {
  const { user = { username: "jygd" }, expanded, onLogoutClick } = props;
  return (
    <>
      <div className="cecoadmin-menu__footer-user">
        <div>
          <AvatarLetter size="big" userName={user.username} expanded={expanded} />

          {expanded && (
            <p>
              {user?.username}
              <br />
              {user?.mail}
            </p>
          )}
        </div>
        <Logout onClick={onLogoutClick} />
      </div>
      <div className="cecoadmin-menu_version">
        <p>v{packageJson.version}</p>
      </div>
    </>
  );
}
